import React, {Component} from 'react';

class PermissionsRow extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        rolePermissions: this.props.role.permissions
    };

    render() {
        const {role, permissions} = this.props;
        return (
            <tr>
                <td className="p-a-2">
                    {role.text}
                    <br/>
                    <small className="text-muted">{role.type}</small>
                </td>
                {permissions.map(permission =>
                    <td key={`${role.id}-${permission.id}`}
                        className="p-a-2 valign-middle">
                        <label className="switcher switcher-success">
                            <input type="checkbox"
                                   checked={this.state.rolePermissions[permission.id]}
                                   onChange={event => this.updateRolePermissions(permission.id, event.target.checked)}/>
                            <div className="switcher-indicator">
                                <div className="switcher-yes">ВКЛ</div>
                                <div className="switcher-no">ВЫКЛ</div>
                            </div>
                        </label>
                    </td>
                )}
            </tr>
        );
    }

    updateRolePermissions(permissionId, flag) {
        const {onChange} = this.props;
        let {rolePermissions} = this.state;

        rolePermissions[permissionId] = flag;

        this.setState({rolePermissions});
        if (onChange)
            onChange(rolePermissions);
    }
}

export default PermissionsRow;


// WEBPACK FOOTER //
// ./src/pages/System/Permissions/components/PermissionsRow.js